import type { HTMLAttributes, ReactNode } from 'react';
import './FormControls.css';

interface InlineAlertProps extends HTMLAttributes<HTMLParagraphElement> {
  variant?: 'error' | 'success';
  children: ReactNode;
}

/** Generic inline error/success banner. `role="alert"` so screen readers announce it as soon as it
 * appears; the leading icon glyph means the state is never conveyed by color alone (SRS accessibility
 * requirement). Justified as a shared primitive because MFA/lockout/password-recovery all need the same
 * banner. */
export function InlineAlert({ variant = 'error', children, className, ...rest }: InlineAlertProps) {
  const classes = ['inline-alert', `inline-alert--${variant}`, className].filter(Boolean).join(' ');
  return (
    <p {...rest} className={classes} role="alert">
      <span className="inline-alert-icon" aria-hidden="true">
        {variant === 'error' ? '⚠' : '✓'}
      </span>
      {children}
    </p>
  );
}
